import { useState, useEffect } from 'react';
import { FaqService } from '../api/faq';

export const useFaq = () => {
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadFaq = async () => {
      try {
        const data = await FaqService.fetchFaq();
        setFaq(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadFaq();
  }, []);

  return { faq, loading, error };
};
